import React from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';

import ButtonWhatsApp from '../../shared/components/buttons/ButtonWhatsApp';
import Screen from './screen';
import {getElection} from './store/selectors';

const Help: React.FC = () => {
  const {t} = useTranslation();
  const election = useSelector(getElection);
  const helpHtmlText = election && election.help ? election.help : '';

  return (
    <Screen className="result pb-60">
      <h2 className="primary-title">{t('ajuda.ajuda')}</h2>
      {helpHtmlText && <div dangerouslySetInnerHTML={{__html: helpHtmlText}} />}
      <ButtonWhatsApp />
    </Screen>
  );
};

export default Help;



// WEBPACK FOOTER //
// ./src/features/election/Help.tsx